import React from 'react';
import './Legal.css';

const Privacy = () => {
  return (
    <div className="legal-page">
      <div className="page-header">
        <div className="container">
          <h1>プライバシーポリシー</h1>
        </div>
      </div>
      
      <section className="section">
        <div className="container">
          <div className="legal-content">
            <p>ゴルフ専用アプリケーション「ゴルマチ」（以下「本アプリ」といいます）の運営者（以下「運営者」といいます）は、本アプリの会員及び会員登録希望者（以下「会員等」といいます）の個人情報保護の重要性について認識し、個人情報の保護に関する法律（以下「個人情報保護法」といいます）を遵守すると共に、以下のプライバシーポリシー（以下「本プライバシーポリシー」といいます）に従い、適切な取扱い及び保護に努めます。</p>
            
            <div className="legal-section">
              <h2>1</h2>
              <p>本プライバシーポリシーにおいて、個人情報及び保有個人データとは、個人情報保護法の定義に従うものとし、その他の定義については、「ゴルマチ利用規約」（以下「利用規約」といいます）に従うものとします。</p>
            </div>

            <div className="legal-section">
              <h2>2</h2>
              <p>運営者は、本アプリにおいて、以下の個人情報を取得し、利用目的に従って利用いたします。なお、利用目的達成に向けた処理の方法は、利用規約をご確認ください。</p>
              
              <p><strong>（1）会員等からの取得</strong></p>
              <p><strong>①取得情報：</strong></p>
              <p>1)本アプリの会員登録時に入力する氏名、年代、性別等の情報</p>
              <p>2)プロフィール情報</p>
              
              <p><strong>②利用目的：</strong></p>
              <p>·本アプリの会員登録を受け、会員等の情報を確認又は管理するため</p>
              <p>·本アプリのプロフィール画面に必要な事項を表示するため</p>
              <p>·本アプリの機能提供を行うため</p>
              <p>·本アプリに関する案内のため</p>
              <p>·運営者からの広告、告知、案内等のDMを送信するため</p>
              <p>·利用規約に基づく運営者の行為を実施するため</p>
              <p>·本アプリの運営に関する事務連絡を行うため</p>
              <p>·利用規約に違反する行為に対する対応のため</p>
              <p>·本アプリの改善、新サービスの開発等に役立てるため</p>
              <p>·本アプリ又は他サービス展開のマーケティングに向けた分析を行うため</p>
              <p>·その他、上記利用目的に付随する目的のため</p>
              
              <p><strong>（2）本アプリの問い合わせフォームからの取得</strong></p>
              <p><strong>①取得情報：</strong>氏名、メールアドレス、問い合わせ本文</p>
              <p><strong>②利用目的：</strong>問い合わせ等への対応のため</p>
            </div>

            <div className="legal-section">
              <h2>3</h2>
              <p>クレジットカード番号の取扱いについては、原則として、決済事業者のシステムを通じて行うため、運営者は、当該情報の取得、利用、提供等に直接関与せず、かかる情報の保持はいたしません。</p>
            </div>

            <div className="legal-section">
              <h2>4</h2>
              <p>運営者は、個人情報保護法その他の法令により許容される場合を除き、会員等の同意を得ず、利用目的の達成に必要な範囲を超えて個人情報を取り扱わず、又は第三者に提供いたしません。但し、次の場合はこの限りではありません。なお、本人から利用目的の通知を求められた場合、第8項の手続きに準じて通知いたします。</p>
              <p>（1）法令に基づく場合</p>
              <p>（2）人の生命、身体又は財産の保護のために必要がある場合であって、会員等の同意を得ることが困難であるとき</p>
              <p>（3）公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、会員等の同意を得ることが困難であるとき</p>
              <p>（4）国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、会員等の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき</p>
            </div>

            <div className="legal-section">
              <h2>5</h2>
              <p>運営者は、適正に個人情報を取得し、偽りその他不正の手段により取得しません。また、運営者は、違法又は不当な行為を助長し、又は誘発するおそれがある方法により個人情報を利用しません。</p>
            </div>

            <div className="legal-section">
              <h2>6</h2>
              <p>運営者は、保有個人データについて、漏えい、滅失又はき損の防止等、その管理のために必要かつ適切な安全管理措置を講じます。また、個人データの取扱者に対して、必要かつ適切な監督を行っております。個人データの安全管理措置に関しては、以下のとおりです。</p>
              
              <p>(1)保有個人データの適正な取扱いの確保のため、関係法令等の遵守や質問及び苦情処理の窓口等について、本プライバシーポリシーを策定しております。</p>
              
              <p>(2)保有個人データの取得、利用、保存、提供、削除・廃棄等の段階ごとに、取扱方法や取扱者を定め、運営者所定の手順に従った取扱いを行います。</p>
              
              <p>(3)組織的な安全管理措置として、以下を実施しております。</p>
              <p>①保有個人データの取扱いに関しては、代表自らが責任者となり、個人データを取り扱う業務と範囲を明確化し、随時、個人情報保護法や運営者所定の規律に違反している事実又は兆候を把握するようにしております。</p>
              <p>②保有個人データの取扱状況について、定期的にチェックを行うとともに、自らの個人データの取扱い状況を過信せず、客観的な目線で確認をしております。</p>
              
              <p>(4)人的安全管理措置として、以下を実施しております。</p>
              <p>①保有個人データの取扱いに関して、意識の強化と知識の向上に努めております。</p>
              <p>②保有個人データについて、秘密を保持することとしております。</p>
              
              <p>(5)物理的安全管理措置として、以下を実施しております。</p>
              <p>①保有個人データの取扱区域を限定し、第三者の入退室や持出の制限を行っております。</p>
              <p>②保有個人データを取り扱う機器等の盗難又は紛失等を防止するための措置を講じるとともに、持ち運ぶ場合においても容易に個人データが判明しないよう措置を実施しております。</p>
              
              <p>(6)技術的安全管理措置として以下を実施しております。</p>
              <p>①パスワードやアクセス制御等によって、保有個人データを保護しております。</p>
              <p>②ウィルス対策や通信暗号化等によって、保有個人データへの不正アクセス等を防止する仕組みを導入しております。</p>
              
              <p>(7)運営者は、運営者が意図して保有個人データを外国に保管し、取り扱わせることは、ありません。</p>
            </div>

            <div className="legal-section">
              <h2>7</h2>
              <p>運営者は、個人情報保護法その他の法令に基づき開示が認められる場合を除くほか、あらかじめ会員等の同意を得ないで、個人情報を第三者に提供しません。但し、次に掲げる場合は上記に定める第三者への提供には該当しません。</p>
              <p>（1）運営者が利用目的の達成に必要な範囲内において個人情報の取扱いの全部又は一部を委託することに伴って個人情報を提供する場合</p>
              <p>（2）合併その他の事由による事業の承継に伴って個人情報が提供される場合</p>
              <p>（3）個人情報保護法の定めに基づき共同利用する場合</p>
            </div>

            <div className="legal-section">
              <h2>8</h2>
              <p>運営者は、会員等から、個人情報保護法の定めに基づき保有個人データ又は第三者提供記録等の開示を求められたときは、会員等ご本人からのご請求であることを確認の上で、会員等に対し、遅滞なく開示を行います（当該保有個人データ又は第三者提供記録等が存在しないときにはその旨を通知いたします）。但し、個人情報保護法その他の法令により、運営者が開示の義務を負わない場合は、この限りではありません。</p>
            </div>

            <div className="legal-section">
              <h2>9</h2>
              <p>運営者は、会員等から、個人情報保護法の定めに基づき保有個人データの内容の訂正、追加又は削除（以下「訂正等」といいます）を求められた場合には、会員等ご本人からのご請求であることを確認の上で、利用目的の達成に必要な範囲内において、遅滞なく必要な調査を行い、その結果に基づき、当該保有個人データの内容の訂正等を行い、その旨を会員等に通知します（訂正等を行わない旨の決定をしたときは、会員等に対しその旨を通知いたします）。但し、個人情報保護法その他の法令により、運営者が訂正等の義務を負わない場合は、この限りではありません。</p>
            </div>

            <div className="legal-section">
              <h2>10</h2>
              <p>運営者は、会員等から、個人情報保護法の定めに基づき保有個人データの利用や提供の停止又は消去（以下「利用停止等」といいます）を求められた場合において、そのご請求に理由があることが判明した場合には、会員等ご本人からのご請求であることを確認の上で、遅滞なく当該保有個人データの利用停止等を行い、その旨を会員等に通知します。但し、個人情報保護法その他の法令により、運営者が利用停止等の義務を負わない場合は、この限りではありません。</p>
            </div>

            <div className="legal-section">
              <h2>11</h2>
              <p>運営者は、Cookie及びこれに類する技術を利用する方法により、会員等から、情報を取得することがあります。</p>
              <p>（1）入力補助、アクセス解析、広告配信サービスの利用のため、Cookieを通じて情報取得を行うことがあります。</p>
              <p>（2）Cookieは会員のコンピュータ内に記録されますが、個人を特定するものは一切含まれません。Cookieを無効化したい会員は、ウェブブラウザの設定を変更することによりCookieを無効化することができます。</p>
              <p>（3）但し、Cookieを無効化すると、運営者のサービスの一部の機能をご利用いただけなくなる場合があります。</p>
            </div>

            <div className="legal-section">
              <h2>12</h2>
              <p>開示等のお申出、ご意見、ご質問、苦情のお申出その他個人情報の取扱い又は運営者の氏名及び住所に関するお問い合わせは、本アプリの問い合わせフォーム等を通じて、運営者までご連絡ください。</p>
            </div>

            <div className="legal-section">
              <h2>13</h2>
              <p>運営者は、個人情報の取扱いに関する運用状況を適宜見直し、継続的な改善に努めるものとし、必要に応じて、本プライバシーポリシーを改定することがあります。改定の方法は、利用規約に準じるものとします。</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;